var map = {
	"./JG Printing Logo_header.png": 9617,
	"./JG Printing Tagline_footer.png": 5220,
	"./JG Printing.jpg": 2378,
	"./JG Printing.png": 4766,
	"./Lazada_Icon.png": 6951,
	"./TikTok_Shop_icon.png": 247,
	"./email-icon.png": 8358,
	"./lazada_section.png": 5555,
	"./shopee_icon.png": 6280,
	"./shopee_section.png": 6286,
	"./tiktok_section.png": 7918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9514;